const context = require.context('./items', true, /\.js$/);

export const usersCases = context
  .keys()
  .map((key) => context(key).default)
  .filter((item) => item && item.slug)
  .sort((a, b) => {
    const aOrder = a.order ?? 9999;
    const bOrder = b.order ?? 9999;
    if (aOrder !== bOrder) return aOrder - bOrder;

    const aTitle = a.title ?? '';
    const bTitle = b.title ?? '';
    return aTitle.localeCompare(bTitle);
  });

export const usersCasesBySlug = Object.fromEntries(
  usersCases.map((item) => [item.slug, item]),
);

export const getUserCaseBySlug = (slug) => usersCasesBySlug[slug] || null;

export const getRelatedCases = (caseItem) => (caseItem?.related || [])
  .map((slug) => usersCasesBySlug[slug])
  .filter(Boolean);
